import {Alert, Button, Separator, Table, TableRow} from 'platform/components';
import {Box, HStack, Text, VStack, Align} from 'platform/foundation';

import {BillingInformationDifferenceResponseBody, BillingInformationSource} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {EMPTY_PLACEHOLDER} from '@dms/shared';

import {getBillingInformationFieldTranslationKey} from '../../../../utils/getBillingInformationFieldTranslationKey';

interface BillingInformationMismatchDialogProps {
  differences: BillingInformationDifferenceResponseBody[];
  onSelect: (source: BillingInformationSource) => void;
}

const columns = [
  {element: null},
  {
    element: (
      <Align left>
        <Text size="small" alternative>
          {i18n.t('entity.saleVehicle.labels.selling')}
        </Text>
      </Align>
    ),
  },
  {
    element: (
      <Align left>
        <Text size="small" alternative>
          {i18n.t('entity.businessCase.labels.buying')}
        </Text>
      </Align>
    ),
  },
];

export function BillingInformationMismatchDialog(props: BillingInformationMismatchDialogProps) {
  return (
    <VStack spacing={4}>
      <Alert
        variant="warning"
        message={i18n.t('entity.businessCase.billingInformationComparison.description')}
      />
      <Box paddingHorizontal={4}>
        <Table columns={columns}>
          {props.differences.map((difference) => (
            <TableRow key={difference.field}>
              <Box paddingVertical={3}>
                <Text color="tertiary" size="small">
                  {i18n.t(getBillingInformationFieldTranslationKey(difference.field))}
                </Text>
              </Box>
              <Box paddingVertical={3}>
                <Text size="small">{difference.sellingValue ?? EMPTY_PLACEHOLDER}</Text>
              </Box>
              <Box paddingVertical={3}>
                <Text size="small">{difference.buyingValue ?? EMPTY_PLACEHOLDER}</Text>
              </Box>
            </TableRow>
          ))}
        </Table>
      </Box>
      <Separator spacing={0} />
      <VStack spacing={2}>
        <HStack spacing={2} justify="center" wrap>
          <Button
            variant="outlined"
            wrap
            title={i18n.t(
              'entity.businessCase.billingInformationComparison.action.useBuyingBranch'
            )}
            onClick={() => props.onSelect('buyingBusinessCaseBranch')}
          />
          <Button
            variant="outlined"
            wrap
            title={i18n.t(
              'entity.businessCase.billingInformationComparison.action.useSaleVehicleBranch'
            )}
            onClick={() => props.onSelect('saleVehicleBranch')}
          />
        </HStack>
        <HStack justify="center">
          <Button
            variant="primary"
            title={i18n.t(
              'entity.businessCase.billingInformationComparison.action.continueWithoutChanges'
            )}
            onClick={() => props.onSelect('sellingBusinessCaseBranch')}
          />
        </HStack>
      </VStack>
    </VStack>
  );
}
